const MASK_CHAR = '*';
const MASK_TAIL_LENGTH = 3;

/**
 * Masks the last few characters of a search term before it's logged — the term is a customer's name,
 * so it goes to NR in this reduced form rather than verbatim. Always leaves at least one character
 * visible; never masks an already-empty string.
 */
export const maskSearchTerm = (term: string): string => {
    const maskLength = Math.min(MASK_TAIL_LENGTH, term.length - 1);
    if (maskLength <= 0) return term;
    return term.slice(0, term.length - maskLength) + MASK_CHAR.repeat(maskLength);
};
